/**
 * Haushaltssituation → zählt ein Partner mit?
 *
 * EINE Regel für Vorschau UND Buchung (Entscheid Alex 06.08.2026, Nachtrag zu
 * Decision #146, `docs/decisions/2026-08-06-mini-einstufung-netto-haushalt.md`).
 *
 * WARUM DAS EINE EIGENE DATEI IST. Die Liste stand vorher dreimal im Baum
 * (`buildWizardCustomerPayload`, `foerderrechner.getHaushaltssituationWert`,
 * `Step1Haushalt.PARTNER_HAUSHALT`) — und die beiden Payload-Bauer wandten sie
 * unterschiedlich an: `buildWizardCustomerPayload` setzte `partner_data` bei
 * einem Nicht-Partner-Haushalt auf `null`, der `routeLead`-Payload schickte
 * `partner_net_salary`/`partner_birth_year` dagegen bedingungslos.
 *
 * Folge: dieselbe Person, derselbe Moment, zwei Zahlen —
 *   Vorschau  net 1500 + Partner 1200 = 2700  → `standard-eb`
 *   Buchung   net 1500                        → `mini-eb`
 * Beide gegen dieselbe 2000er-Schwelle. Genau die Divergenz, die Decision #146
 * beseitigen sollte; die Rechenfunktion war danach eine, die DATEN der beiden
 * Aufrufer nicht. Deshalb hängt hier die Regel und nicht am Aufrufer.
 *
 * Aufräumen der Felder findet bewusst NICHT statt: `Step1Haushalt` schreibt die
 * Partner-Werte weiter in den Store zurück, und `buildWizardDataFromCustomer`
 * hydratisiert sie bei Bestandskunden aus `partner_data`. Das ist gewollt — wer
 * die Haushaltssituation versehentlich umstellt und zurückstellt, soll seine
 * Eingaben nicht verloren haben. Gefiltert wird erst beim Bauen des Payloads,
 * und zwar auf beiden Wegen gleich.
 */

/** Familienstände, bei denen die Partner-Sektion erscheint und der Partner zählt. */
export const PARTNER_HAUSHALTSSITUATIONEN: readonly string[] = ['paar', 'verheiratet'];

/** Zählt bei dieser Haushaltssituation ein Partner mit (Einkommen + Alter)? */
export function hatPartner(haushaltssituation: string | null | undefined): boolean {
  return haushaltssituation != null && PARTNER_HAUSHALTSSITUATIONEN.includes(haushaltssituation);
}
